export default{
  init(){
    require("./infinite_scroll");
    require("./keep_scroll_postion");
    // require("./through_scroll");
  }
}
